import { UserPermissions } from "@redotech/redo-model/permissions";
import { createContext, useContext } from "react";
import { UserContext } from "../user";

export const PermissionsContext = createContext<
  Set<UserPermissions> | undefined
>(undefined);

export function useHasPermission(
  ...permissionsToCheck: UserPermissions[]
): boolean {
  const userPermissions = useContext(PermissionsContext);

  if (!userPermissions) {
    return false;
  }

  return permissionsToCheck.some((permission) =>
    userPermissions.has(permission),
  );
}

export function useIsRedoAdmin(): boolean {
  const user = useContext(UserContext);
  if (!user) {
    return false;
  }
  return (
    user.email.trim().toLowerCase().endsWith("@getredo.com") ||
    user.email.trim().toLowerCase().endsWith("@redo.com")
  );
}
